import {Component, OnInit} from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
    selector: 'app-refundpolicy',
    templateUrl: './refundpolicy.component.html',
    styleUrls: ['./refundpolicy.component.scss']
})
export class RefundpolicyComponent implements OnInit {

    constructor(
        private meta: Meta,
        private titles: Title
    ) {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('ARNI Refund Policy: Clear Guidelines for Students');
        this.meta.updateTag({
            name: 'description',
            content: `Explore the ARNI Refund Policy for detailed information on eligibility, process, and conditions, ensuring a transparent and fair experience for all students.`
        });
    }

}
